import * as React from "react";

const SvgPublishHubFilled = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 21 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.84845 3.9092V8.6214C9.84845 8.89755 10.0723 9.1214 10.3484 9.1214H10.6515C10.9276 9.1214 11.1515 8.89755 11.1515 8.6214V3.9092H13.202C13.6475 3.9092 13.8706 3.37063 13.5556 3.05565L10.8535 0.3536C10.6583 0.158338 10.3417 0.158338 10.1464 0.3536L7.44437 3.05565C7.12939 3.37063 7.35247 3.9092 7.79793 3.9092L9.84845 3.9092ZM1.25 4.00005C0.835786 4.00005 0.5 4.33583 0.5 4.75005V15.25C0.5 15.6643 0.835786 16 1.25 16C1.66421 16 2 15.6643 2 15.25V4.75005C2 4.33583 1.66421 4.00005 1.25 4.00005ZM19.75 4.00005C19.3358 4.00005 19 4.33583 19 4.75005V15.25C19 15.6643 19.3358 16 19.75 16C20.1642 16 20.5 15.6643 20.5 15.25V4.75005C20.5 4.33583 20.1642 4.00005 19.75 4.00005ZM5.5 3.00005H6.5V10H14.5V3.00005H15.5C16.6046 3.00005 17.5 3.89548 17.5 5.00005V15C17.5 16.1046 16.6046 17 15.5 17H5.5C4.39543 17 3.5 16.1046 3.5 15V5.00005C3.5 3.89548 4.39543 3.00005 5.5 3.00005Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgPublishHubFilled;
